import styled from 'styled-components/macro';

import { Button } from 'src/client/components/ui/Button';

export const FullScreenImageViewerFrame = styled.div`
  position: fixed;
  overflow: auto;
  z-index: 9999999999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.primary1};
  font-size: 0.85rem;
  -webkit-user-select: none;
  user-select: none;

  @media (max-width: 767px) {
    height: 100%;
  }
`;

export const ViewerHeader = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  display: flex;
  height: 40px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  background: rgba(255, 255, 255, 0.5);
  font-size: 1.05rem;
  transition: opacity 0.3s ease;

  &.dark {
    background: rgba(0, 0, 0, 0.8);
  }

  ${FullScreenImageViewerFrame}.idle & {
    opacity: 0;
    pointer-events: none;
  }
`;

export const ViewerButton = styled(Button)`
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  transition: opacity 0.3s ease;

  @media (min-width: 1036px) {
    opacity: 0.6;
  }

  &:hover {
    opacity: 1;
  }
`;

export const ViewerPagination = styled.span`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 8px;
  padding: 0;
  margin: 0;
`;
